<template>
  <div class="min-h-screen bg-elevated/10">
    <header class="border-b border-default bg-background/60 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div class="max-w-5xl mx-auto px-4 py-4 flex items-center justify-between">
        <NuxtLink to="/" class="text-xl font-semibold">Lodge</NuxtLink>
        <div class="flex items-center gap-2">
          <UButton to="/login" variant="ghost" color="neutral" icon="i-lucide-log-in" label="Admin" />
        </div>
      </div>
    </header>

    <main class="max-w-5xl mx-auto px-4 py-8">
      <slot />
    </main>
  </div>
</template>

